export enum SurveyMeasurementStatuses {
  Complete = 'Complete',
  InProgress = 'InProgress',
  Pending = 'Pending',
  CompleteWithAlarm = 'CompleteWithAlarm',
  UnAssigned = 'UnAssigned',
}
